const AUTH_SOURCE_STORAGE_KEY = 'auth_flux_source'
const AUTH_RETURN_URL_STORAGE_KEY = 'auth_flux_return_url'
const AUTH_REQUESTED_PATH_STORAGE_KEY = 'auth_flux_requested_path'
const AUTH_PHONE_NUMBER_STORAGE_KEY = 'auth_flux_user_mobile'
const AUTH_MUID_STORAGE_KEY = 'auth_flux_muid'
const AUTH_OTP_ID_STORAGE_KEY = 'auth_flux_otp_id'
const AUTH_PENDING_EMAIL_OTP_KEY = 'auth_flux_pending_email_otp'
const AUTH_PENDING_PHONE_OTP_KEY = 'auth_flux_pending_phone_otp'

const getSessionStorage = () => {
  try {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null
  } catch {
    return null
  }
}

const getStoredValue = key => getSessionStorage()?.getItem(key) ?? null

const setStoredValue = (key, value) => {
  const storage = getSessionStorage()
  if (!storage) return

  if (value) {
    storage.setItem(key, value)
  } else {
    storage.removeItem(key)
  }
}

export const getStoredSource = () => getStoredValue(AUTH_SOURCE_STORAGE_KEY)

export const setStoredSource = source => {
  if (source) {
    setStoredValue(AUTH_SOURCE_STORAGE_KEY, source)
  }
}

export const clearStoredSource = () => {
  setStoredValue(AUTH_SOURCE_STORAGE_KEY, null)
}

export const getStoredReturnUrl = () => getStoredValue(AUTH_RETURN_URL_STORAGE_KEY)

export const setStoredReturnUrl = returnUrl => {
  setStoredValue(AUTH_RETURN_URL_STORAGE_KEY, returnUrl)
}

/** Path and query the user tried to open before being sent to login. */
export const getStoredRequestedPath = () => getStoredValue(AUTH_REQUESTED_PATH_STORAGE_KEY)

export const setStoredRequestedPath = path => {
  setStoredValue(AUTH_REQUESTED_PATH_STORAGE_KEY, path)
}

export const getStoredMobile = () => getStoredValue(AUTH_PHONE_NUMBER_STORAGE_KEY)

export const setStoredMobile = phoneNumber => {
  setStoredValue(AUTH_PHONE_NUMBER_STORAGE_KEY, phoneNumber)
}

export const getStoredMuid = () => getStoredValue(AUTH_MUID_STORAGE_KEY)

export const setStoredMuid = muid => {
  setStoredValue(AUTH_MUID_STORAGE_KEY, muid)
}

export const getStoredOtpId = () => getStoredValue(AUTH_OTP_ID_STORAGE_KEY)

export const setStoredOtpId = otpId => {
  setStoredValue(AUTH_OTP_ID_STORAGE_KEY, otpId)
}

export const getStoredPendingEmailOtp = () => getStoredValue(AUTH_PENDING_EMAIL_OTP_KEY)

export const setStoredPendingEmailOtp = email => {
  setStoredValue(AUTH_PENDING_EMAIL_OTP_KEY, email)
}

export const getStoredPendingPhoneOtp = () => getStoredValue(AUTH_PENDING_PHONE_OTP_KEY)

export const setStoredPendingPhoneOtp = mobile => {
  setStoredValue(AUTH_PENDING_PHONE_OTP_KEY, mobile)
}

/** Clears logged-in session markers (keeps OTP-in-progress and product context). */
export const clearAuthenticatedSession = () => {
  setStoredMuid(null)
  setStoredRequestedPath(null)
}

/** Clears temporary authentication data but keeps source and return URL. */
export const clearAuthSession = () => {
  clearAuthenticatedSession()
  setStoredMobile(null)
  setStoredOtpId(null)
  setStoredPendingEmailOtp(null)
  setStoredPendingPhoneOtp(null)
}
